(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["storage-bike-interactive"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-storage-bikes]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const choices = [...root.querySelectorAll('[data-bike-select]')];
      const panels = [...root.querySelectorAll('[data-bike-panel]')];
      const triggers = [...root.querySelectorAll('[data-bike-trigger]')];
      const stage = root.querySelector('.storage-bikes__stage');
      const wheelieButton = root.querySelector('.storage-bikes__wheelie');
      const status = root.querySelector('[data-bike-status]');
      const hint = root.querySelector('[data-bike-hint]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animationFrame;
      const stop = () => { cancelAnimationFrame(animationFrame); root.classList.remove('is-wheelie'); };
      const wheelie = () => {
        if (root.classList.contains('is-hovering')) return;
        stop();
        if (motion.matches) return;
        animationFrame = requestAnimationFrame(() => {
          animationFrame = requestAnimationFrame(() => root.classList.add('is-wheelie'));
        });
      };
      const updateMotion = () => {
        stop();
        root.classList.remove('is-hovering');
        triggers.forEach(button => { button.disabled = motion.matches; });
        if (wheelieButton) wheelieButton.hidden = motion.matches;
        if (hint) hint.textContent = motion.matches ? root.dataset.staticHint : root.dataset.hint;
      };
      choices.forEach(choice => {
        choice.disabled = false;
        choice.addEventListener('click', () => {
          const color = choice.dataset.bikeSelect;
          const name = choice.dataset.colorName;
          root.dataset.color = color;
          choices.forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
          panels.forEach(panel => { panel.hidden = panel.dataset.bikePanel !== color; });
          if (status) status.textContent = root.dataset.statusTemplate.replace('__COLOR__', name);
          if (stage) stage.setAttribute('aria-label', root.dataset.wheelieTemplate.replace('__COLOR__', name));
          wheelie();
        });
      });
      triggers.forEach(button => button.addEventListener('click', wheelie));
      if (stage) {
        stage.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && !motion.matches) { stop(); root.classList.add('is-hovering'); } });
        stage.addEventListener('pointerleave', () => root.classList.remove('is-hovering'));
      }
      root.addEventListener('animationend', event => { if (event.animationName === 'storage-bike-wheelie') root.classList.remove('is-wheelie'); });
      motion.addEventListener('change', updateMotion);
      document.addEventListener('visibilitychange', () => { if (document.hidden) { stop(); root.classList.remove('is-hovering'); } });
      updateMotion();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["storage-sport-story"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-storage-sport]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const video = root.querySelector('video');
      const button = root.querySelector('[data-sport-toggle]');
      const label = root.querySelector('[data-sport-toggle-label]');
      const error = root.querySelector('[data-sport-error]');
      if (!video || !button || !label) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = motion.matches;
      let visible = false;
      video.muted = true;
      video.controls = false;
      button.hidden = false;
      const update = () => {
        const playing = !video.paused && !video.ended;
        root.classList.toggle('is-playing', playing);
        const text = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.setAttribute('aria-label', text);
        button.setAttribute('aria-pressed', String(playing));
        label.textContent = text;
      };
      const play = () => {
        if (!visible || userPaused || document.hidden) return;
        const result = video.play();
        if (result) result.catch(update);
      };
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { button.hidden = true; if (error) error.hidden = false; });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
      motion.addEventListener('change', () => { if (motion.matches) { userPaused = true; video.pause(); } });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          if (visible) play(); else video.pause();
        }, { threshold: .15 });
        observer.observe(video);
      } else { visible = true; play(); }
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
